import { useEffect, useState } from "react";
import { useFetch } from "../../../hooks/useFetch";
import { listDocumentsSafeCarsService } from "../services/listDocumentsSafeCars.service";

export const useDocumentsSafeCarsQuery = () => {
  const fetchData = useFetch();

  const [documentsSafeCars, setDocumentsSafeCars] = useState({});
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchDocumentsSafeCars = async () => {
      try {
        setLoading(true);
        const response = await listDocumentsSafeCarsService(fetchData)();
        const docs = Array.isArray(response) ? response : [];
        const documents = Object.keys(docs[0] || {}).reduce((acc, key) => {
          const value = docs[0][key];
          if (
            value &&
            isNaN(Number(value)) &&
            !value.includes("pdfsVehiculosSeguros")
          ) {
            acc[key] = "pdfsVehiculosSeguros/" + response[0][key];
          }

          return acc;
        }, {});

        setDocumentsSafeCars(documents);
      } catch (error) {
        console.log(
          "Error al obtener los documentos de vehiculos seguros",
          error
        );
      } finally {
        setLoading(false);
      }
    };

    fetchDocumentsSafeCars();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  return { documentsSafeCars, loading, refresh: () => setRefresh(!refresh) };
};
